import { FilterConfiguration, FilterOperator, FilterType } from '@rms/ui/filters';

import { PARTNER_STATUS } from './partner.model';

export const PARTNER_ID_PARAMETER = 'partnerId';

export const PARTNER_STATUS_LABELS: Readonly<Record<PARTNER_STATUS, string>> = {
  [PARTNER_STATUS.ACTIVE]: 'partners.status.active',
  [PARTNER_STATUS.DISABLED]: 'partners.status.disabled',
};

export const PARTNER_FILTERS: FilterConfiguration[] = [
  {
    filter: 'name',
    label: 'partners.filters.name',
    type: FilterType.TEXT,
    operators: [FilterOperator.CONTAINS],
    unique: true,
  },
  {
    filter: 'status',
    label: 'partners.filters.status',
    type: FilterType.SELECT,
    operators: [FilterOperator.IS],
    options: Object.values(PARTNER_STATUS).map((status) => ({ value: status, label: PARTNER_STATUS_LABELS[status] })),
    unique: true,
  },
];

// Limits mirror the organization-service partner create request
export const PARTNER_DISPLAY_NAME_MAX_LENGTH = 200;
export const PARTNER_SLUG_MIN_LENGTH = 2;
export const PARTNER_SLUG_MAX_LENGTH = 20;
export const PARTNER_SLUG_PATTERN = /^[a-z0-9-]+$/;
export const PARTNER_EMAIL_MAX_LENGTH = 250;
export const PARTNER_LOGO_MAX_LENGTH = 512;
export const PARTNER_LOGO_PATTERN = /^https:\/\/\S+$/;
